import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import s from '../../styles/corporate/Corporate.module.css';
import { APPLY_PATH, NAV } from './data';
import { asset } from './Shot';

/** 기업 소개 메인 헤더 — 가운데 앵커 메뉴, 오른쪽은 BNPL 접수 페이지로 보내는 버튼 */
const CorpHeader = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <header className={s.header}>
      <div className={`${s.wrap} ${s.headerInner}`}>
        <button type="button" className={s.brand} onClick={() => go('top')}>
          <img
            className={s.brandMark}
            src={asset('logo.png')}
            width="44"
            height="44"
            alt=""
            aria-hidden="true"
          />
          <span className={s.brandName} translate="no">
            OFFER GROUP
          </span>
        </button>

        <nav className={`${s.nav} ${open ? s.navOpen : ''}`} aria-label="주요 메뉴">
          {NAV.map((item) => (
            <button type="button" className={s.navItem} key={item.id} onClick={() => go(item.id)}>
              {item.label}
            </button>
          ))}
        </nav>

        <button
          type="button"
          className={s.menuBtn}
          aria-expanded={open}
          aria-label="메뉴 열기"
          onClick={() => setOpen((prev) => !prev)}
        >
          {open ? '✕' : '☰'}
        </button>

        <Link className={s.headerCta} to={APPLY_PATH} translate="no">
          BNPL 서비스 ↗
        </Link>
      </div>
    </header>
  );
};

export default CorpHeader;
